import reauthenticateSaga from './reauthenticateSaga';
import resetPasswordSaga from './resetPasswordSaga';
import sendTourReviewSaga from './sendTourReviewSaga';
import fetchTourSaga from './fetchTourSaga';

const sagas = [...reauthenticateSaga, ...resetPasswordSaga, ...sendTourReviewSaga, ...fetchTourSaga];

export default sagas;
